const DEFAULT = 'DEFAULT';
const ROLLUP = 'ROLLUP';
const ROLLUP_SHOW_BREAKDOWN = 'ROLLUP_SHOW_BREAKDOWN';
const ROLLUP_SHOW_PRICE_COMPONENTS = 'ROLLUP_SHOW_PRICE_COMPONENTS';

export default  {
  DEFAULT,
  ROLLUP,
  ROLLUP_SHOW_BREAKDOWN,
  ROLLUP_SHOW_PRICE_COMPONENTS
};



// WEBPACK FOOTER //
// ./frontend/react/components/edp/basket/recap/feerollup_states.js